//
// Definitions
//

/** Token Patterns - same as from npm vue-the-mask */
const TOKENS = {
  '#': {pattern: /\d/},
  'X': {pattern: /[0-9a-zA-Z]/},
  'S': {pattern: /[a-zA-Z]/},
  'A': {pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase()},
  'a': {pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase()},
  '!': {escape: true}
};

//
// Public Interface
//

/**
 * A Vue directive for masking string input.
*/
export default {
  bind: function (element, binding) {
    element = firstInputChild(element);
    element.dataset.mask = binding.value;

    element.oninput = function(event) {
      if (!event.isTrusted) {
        return;
      }

      let currentVal = element.value;
      let currentCursor = element.selectionEnd;

      let maskedInput = applyMask(currentVal, element.dataset.mask);
      let maskedPartial = applyMask(currentVal.substr(0, currentCursor), element.dataset.mask);

      let delta = maskedPartial.length - currentCursor;

      if (delta > 0) {
        currentCursor = Math.min(currentCursor + delta, maskedPartial.length);
      }

      element.value = maskedInput;
      element.selectionEnd = currentCursor;

      window.setTimeout(() => element.dispatchEvent(cloneEvent(event), 0));
    };
    
  },

  componentUpdated: function(element, binding) {
    // componentUpdated called when the 'v-mask' value of the component changes.
    element = firstInputChild(element);
    element.dataset.mask = binding.value;
  },

  unbind: function (element) {
    element = firstInputChild(element);
    element.onpaste = element.oncut = element.onclick = element.onkeyup = element.oninput = undefined;
  }
};

//
// Implementation
//

/**
 * Clone a DOM event and initialize it so it may be dispatched.
 * 
 * @param {Event} e a DOM event object
 * @returns {Event} a newly initialized DOM event
 */
function cloneEvent(e) {
  var clone = document.createEvent("HTMLEvents");
  clone.initEvent(e.type, e.bubbles, e.cancelable);
  return clone;
}

/**
 * Return the first child of the given element that is an Input element,
 * or the element if it is itself one.
 * 
 * @param {HTMLElement} element a DOM element
 * @returns {HTMLInputElement} an DOM Input element
 * @throws {Error} if no Input element is found
 */
function firstInputChild(element) {
  if (element.tagName.toLocaleUpperCase() == "INPUT") {
    return element;
  }

  var inputs = element.getElementsByTagName("input");
  if (!inputs.length) {
    throw new Error("Mask Directive requires an HTMLInputElement child.");
  }

  return inputs[0];
}

/**
 * Apply a token mask to the given string.
 * 
 * Implementation from npm vue-the-mask:
 * @link https://www.npmjs.com/package/vue-the-mask
 * 
 * @param {String} input the string to mask
 * @param {String} mask the mask format
 * @returns {String} the masked string result
 */
function applyMask(input, mask) {
  input = input || "";
  mask = mask || "";
  let iMask = 0;
  let iValue = 0;
  let output = "";

  while (iMask < mask.length && iValue < input.length) {
    let cMask = mask[iMask];
    let masker = TOKENS[cMask];
    let cValue = input[iValue];

    if (masker && !masker.escape) {
      if (masker.pattern.test(cValue)) {
        // transform if set
        output += masker.transform ? masker.transform(cValue) : cValue;
        iMask++;
      }
      iValue++;
    } else {
      if (masker && masker.escape) {
        iMask++;
        cMask = mask[iMask];
      }
      output += cMask;

      if (cValue === cMask) {
        iValue++;
      }

      iMask++;
    }
  }

  let restOutput = "";
  while (iMask < mask.length) {
    let cMask = mask[iMask];
    if (TOKENS[cMask]) {
      restOutput = "";
      break;
    }
    restOutput += cMask;
    iMask++;
  }

  let result = output + restOutput;
  return result;
}

